import { render } from "./AuMarkdown.vue?vue&type=template&id=a4e8f502&scoped=true"
import script from "./AuMarkdown.vue?vue&type=script&lang=js"
export * from "./AuMarkdown.vue?vue&type=script&lang=js"

import "./AuMarkdown.vue?vue&type=style&index=0&id=a4e8f502&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4e8f502"]])

export default __exports__